'use strict';
var IbmBackToTop = (function () {
    function IbmBackToTop() {
        this.restrict = 'A';
    }
    IbmBackToTop.instance = function () {
        return new IbmBackToTop;
    };
    IbmBackToTop.prototype.link = function (scope, element) {
        var isActive = false, didScroll = false, windowHeight = $(window).height();
        var buttonAppendTo = $('#ibm-content-body')[0], buttonText = 'Back';
        $(window).scroll(function () {
            didScroll = true;
        });
        setInterval(function () {
            if (didScroll) {
                didScroll = false;
                toggleBackToTop();
            }
        }, 500);
        $(function () {
            // Remove any existing one b/c we're injecting a new one (for cases dynamic locale change).
            $(buttonAppendTo).find('.ibm-btt-auto').remove();
            var appel = '<p class="ibm-ind-link ibm-nospacing ibm-icononly ibm-btt-auto ibm-hidden-small">' +
                '<a class="ibm-nospacing ibm-chevron-up-link" aria-label="' +
                buttonText + '" href="#top">' + buttonText + '</a></p>';
            $(appel)
                .appendTo(buttonAppendTo)
                .children('a')
                .attr('tabindex', '-1')
                .click(function (evt) {
                var duration = ($(window).scrollTop() / 2);
                evt.preventDefault();
                $('html, body').animate({
                    scrollTop: 0
                }, duration);
            });
            toggleBackToTop();
        });
        function toggleBackToTop() {
            //console.log('$(window)=', $(window));
            if ($(window).scrollTop() > windowHeight && !isActive) {
                $('.ibm-btt-auto').addClass('ibm-active').children('a').attr('tabindex', '0');
                isActive = true;
            }
            else if ($(window).scrollTop() < windowHeight && isActive) {
                $('.ibm-btt-auto').removeClass('ibm-active').children('a').attr('tabindex', '-1');
                isActive = false;
            }
        }
    };
    return IbmBackToTop;
}());
angular
    .module('application')
    .directive('ibmBackToTop', IbmBackToTop.instance);

//# sourceMappingURL=ibm-back-to-top.js.map
